import { render } from "./WareInPutawayDetail.vue?vue&type=template&id=c383b488&scoped=true"
import script from "./WareInPutawayDetail.vue?vue&type=script&lang=js"
export * from "./WareInPutawayDetail.vue?vue&type=script&lang=js"

import "./WareInPutawayDetail.vue?vue&type=style&index=0&id=c383b488&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c383b488"]])

export default __exports__